module.exports = __webpack_public_path__ + "static/media/DooPrime.4925b672.svg";